const XOR_KEY = 0x1F3D5C;

export function encodeCardId(id: number): string {
  const xored = id ^ XOR_KEY;
  return xored.toString(36).padStart(8, '0');
}

export function decodeCardId(encoded: string): number {
  const xored = parseInt(encoded, 36);
  return xored ^ XOR_KEY;
}

export function slugify(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export function buildCardUrl(id: number, name: string): string {
  const slug = slugify(name);
  const encoded = encodeCardId(id);
  return slug ? `${slug}-${encoded}` : encoded;
}

export function extractCardIdFromUrl(urlParam: string): number {
  // Encoded ID is always 8 lowercase alphanumeric chars, preceded by '-'
  if (urlParam.length > 8 && urlParam[urlParam.length - 9] === '-') {
    const encodedPart = urlParam.slice(-8);
    if (/^[0-9a-z]{8}$/.test(encodedPart)) {
      const id = decodeCardId(encodedPart);
      if (!isNaN(id) && id > 0) return id;
    }
  }
  // URL param is just the encoded ID with no name slug
  if (urlParam.length === 8 && /^[0-9a-z]{8}$/.test(urlParam)) {
    const id = decodeCardId(urlParam);
    if (!isNaN(id) && id > 0) return id;
  }
  // Backward compat: plain numeric ID
  const num = parseInt(urlParam, 10);
  return isNaN(num) ? 0 : num;
}
